import { CountrySelect } from 'components/common/CountrySelect.js';
import { FormGroup, Input, Stack } from 'components/ui';
import { useTranslation } from 'next-i18next';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

const queryCity = async (zip, country, city, update) => {
	const result = await fetch(
		`https://api.kosmos.click/zipcodes/search?code=${zip}&country=${country}`
	);
	const success = await result.json();
	if (success?.city_name && !city) {
		update({ city: success.city_name });
	} else {
		console.error('error');
	}
};

const Location = ({ update, formData, validation }) => {
	const [t] = useTranslation(['translation']);
	const countries = useSelector((state) => state.masterData.countries);
	const { zip, city, country_iso_code } = formData;

	return (
		<FormGroup className='mb-3'>
			<Stack gap={3}>
				<CountrySelect
					label={t('common.land') + ' *'}
					value={country_iso_code}
					isInvalid={
						validation['country_iso_code'] ||
						(countries?.length == 0
							? t('validation.laender.nicht.geladen')
							: '')
					}
					onChange={(newValue) => {
						if (typeof newValue === 'string') {
							const existing = countries.find((land) => {
								return (
									land.country_iso_code &&
									land.country_iso_code.toLowerCase() === newValue.toLowerCase()
								);
							});
							if (existing) {
								update({
									country_iso_code: existing.country_iso_code.toLowerCase(),
								});
							} else {
								update({ country_iso_code: newValue });
							}
						}
					}}
				/>
				<Input
					type='text'
					label={t('impfschaeden.erfassen.postleitzahl')}
					value={zip || ''}
					onChange={(e) => {
						if (e.target.value.length > 3) {
							queryCity(e.target.value, country_iso_code, city, update);
						}
						return update({ zip: e.target.value });
					}}
					name='location_zip'
					id='location_zip_id'
				/>
				<Input
					type='text'
					label={t('common.ort')}
					value={city || ''}
					inputValue={city}
					onChange={(e) => update({ city: e.target.value })}
					name='location_city'
					id='location_city_id'
				/>
			</Stack>
		</FormGroup>
	);
};

Location.propTypes = {
	validation: PropTypes.object,
	formData: PropTypes.object,
	update: PropTypes.func,
};

export { Location };
